import { Button, Badge } from '@e2n/ui';
import { faBell } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonHTMLAttributes } from 'react';

export function BenachrichtigungenTrigger({
  active = false,
  count = 0,
  ...props
}: {
  active?: boolean;
  count?: number;
} & ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <Button
      variant="ghost"
      size="icon"
      className="data-[state=open]:bg-neutrals-300 relative size-8"
      {...props}>
      <FontAwesomeIcon icon={faBell} className="text-neutrals-800" />
      {active && count > 0 && (
        <Badge
          aria-hidden="true"
          className={`absolute top-0 ${
            count < 10 ? 'right-0' : '-right-2'
          } h-4 min-w-4 rounded-full py-0.5 px-1 hover:bg-primary-red-400`}
          variant="destructive">
          {count}
        </Badge>
      )}
    </Button>
  );
}
